// src/components/CarFooterbar.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const CarFooterbar = () => {
  const [footerbarData, setFooterbarData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `https://gestione.carellidistribuzione.it/react-endpoint-api/get-footer-credits?${new Date().getTime()}`
        );
        setFooterbarData(data);
      } catch (error) {
        console.error("Errore durante il caricamento dei dati:", error);
      }
    };
    fetchData();
  }, []);

  // Non montare nulla finché non ho entrambi i pezzi di contenuto
  const footerbarDatas = footerbarData?.data?.[0] ?? null;
  const creditsText   = footerbarData?.data?.[1] ?? null;
  if (!footerbarDatas || !creditsText) {
    return null;
  }

  return (
    <div
      className="d-flex flex-column flex-md-row justify-content-between align-items-start p-2 px-0 px-md-4 gap-3 info-bar"
      style={{ background: "var(--dark-1)" }}
      id='footerBar'
    >
      {/* Prima parte */}
      <div
        className="fw-normal p-2 text-start"
        style={{
          lineHeight: "22px",
          letterSpacing: "-0.43px",
          color: "var(--info-footer)",
        }}
        dangerouslySetInnerHTML={{ __html: footerbarDatas }}
      />

      {/* Seconda parte */}
      <div
        className="fw-normal p-2 text-start"
        style={{
          lineHeight: "22px",
          letterSpacing: "-0.43px",
          color: "var(--info-footer)",
        }}
        dangerouslySetInnerHTML={{ __html: creditsText }}
      />
    </div>
  );
};

export default CarFooterbar;
